import { useEffect, useState } from 'react';
import Fade, { FadeProps } from '@mui/material/Fade';

export type DelayProps = {
    show?: boolean;
    ms?: number;
} & Pick<FadeProps, 'children' | 'unmountOnExit' | 'mountOnEnter' | Extract<keyof FadeProps, `on${string}`>>

export default function Delay({
    children,
    show: showProp = true,
    ms = 200,
    ...fadeProps
}: DelayProps) {
    const [show, setShow] = useState(false);
    useEffect(() => {
        // !showProp means hide, so hide when showProp is false (internal show and showProp should be in agreement before showing anything)
        setShow(show => show && showProp);
    }, [showProp]);

    useEffect(() => {
        if (showProp) {
            const timer = setTimeout(() => setShow(true), ms);
            return () => clearTimeout(timer);
        }
    }, [showProp, ms]);

    return (
        <Fade
            in={show}
            timeout={{ enter: ms }}
            unmountOnExit
            {...fadeProps}
        >
            {children}
        </Fade>
    );
}
